"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var entity_name_provider_service_1 = require("../../../../../../shared/services/api/entity-name-provider.service");
var root_category_summary_page_config_service_1 = require("../../../../../../shared/services/api/summary-pages/root-category-summary-page-config-service");
var dynamic_navigation_helper_1 = require("../../../../common/utils/dynamic-navigation-helper");
var summary_pages_navigation_prefix_1 = require("../../../summary-pages-navigation-prefix");
var HeaderBreadcrumbComponent = /** @class */ (function () {
    function HeaderBreadcrumbComponent(rootCategorySummaryPageConfigService, entityNameProviderService, router, route, navigationPrefix) {
        this.rootCategorySummaryPageConfigService = rootCategorySummaryPageConfigService;
        this.entityNameProviderService = entityNameProviderService;
        this.router = router;
        this.route = route;
        this.navigationPrefix = navigationPrefix;
        this.formId = this.route.snapshot.params['formId'];
    }
    HeaderBreadcrumbComponent_1 = HeaderBreadcrumbComponent;
    HeaderBreadcrumbComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.rootCategoryId) {
            this.breadcrumbItems$ = this.rootCategorySummaryPageConfigService.getConfigByRootCategory(this.rootCategoryId).pipe(operators_1.switchMap(function (rootCategoryConfig) {
                return _this.buildBreadCrumb(rootCategoryConfig);
            }));
        }
    };
    HeaderBreadcrumbComponent.prototype.ngOnDestroy = function () {
    };
    HeaderBreadcrumbComponent.prototype.onNavigate = function (item) {
        var _this = this;
        this.rootCategorySummaryPageConfigService.getConfigByRootCategory(this.rootCategoryId).pipe(operators_1.switchMap(function (rootCategoryConfig) {
            if (item.navigationType === HeaderBreadcrumbComponent_1.NAV_TYPE_BASE) {
                return dynamic_navigation_helper_1.navigateToRootPortfolio(_this.navigationPrefix, _this.rootCategoryId, _this.route, _this.router);
            }
            else if (item.navigationType === HeaderBreadcrumbComponent_1.NAV_TYPE_OVERVIEW) {
                return dynamic_navigation_helper_1.navigateToOverviewForm(_this.navigationPrefix, _this.rootCategoryId, _this.rootEntityId, +rootCategoryConfig.formId, _this.route, _this.router);
            }
            else if (item.navigationType === HeaderBreadcrumbComponent_1.NAV_TYPE_PORTFOLIO) {
                return dynamic_navigation_helper_1.navigateToPortfolio(_this.navigationPrefix, _this.rootCategoryId, _this.rootEntityId, _this.categoryId, _this.route, _this.router);
            }
            return Observable_1.Observable.of(null);
        }), operators_1.take(1)).subscribe();
    };
    /**
     * This method generate breadcrumb to show in form and portfolio headers in case when root entity exist in context
     * The structures of breadcrumb by location
     * The location             : The structure
     * isRootCategoryPortfolio  : /root-category-portfolio-name#
     * isOverviewForm            : /root-category-portfolio-name* /root-category-overview-form#
     * isRootCategoryForm        : /root-category-portfolio-name* /root-category-overview-form*
     * isSingleChildCategoryForm: /root-category-portfolio-name* /root-category-overview-form*
     * isChildCategoryPortfolio    : /root-category-portfolio-name* /root-category-overview-form* /child-category-portfolio#
     * isChildCategoryForm        : /root-category-portfolio-name* /root-category-overview-form* /child-category-portfolio*
     * isCustomPage                : /root-category-portfolio-name* /root-category-overview-form* /page-with-custom-url#
     *
     * * - means the item is link
     * # - means the item is hidden
     * @private
     */
    HeaderBreadcrumbComponent.prototype.buildBreadCrumb = function (rootCategoryConfig) {
        var _this = this;
        // understand location
        var isRootCategoryPortfolio = this.isPortfolio && this.categoryId && this.rootCategoryId === this.categoryId && this.router.url.indexOf('/custom/') === -1;
        var isOverviewPage = !this.isPortfolio && this.categoryId && this.formId && this.rootCategoryId === this.categoryId && ("" + this.formId === "" + rootCategoryConfig.formId);
        var isRootCategoryForm = !this.isPortfolio && this.categoryId && this.formId &&
            this.rootCategoryId === this.categoryId && ("" + this.formId !== "" + rootCategoryConfig.formId);
        var isSingleChildCategoryForm = !this.isPortfolio && this.categoryId && this.formId && this.rootCategoryId !== this.categoryId &&
            rootCategoryConfig.overviewConfigModel.overviewItemsConfig.filter(function (value) { return value.itemCategoryName === _this.categoryId && value.cardType.id === 3; }).length > 0;
        var isChildCategoryPortfolio = this.isPortfolio && this.categoryId && this.rootCategoryId !== this.categoryId;
        var isChildCategoryForm = !this.isPortfolio && this.categoryId && this.formId && this.rootCategoryId !== this.categoryId && !isSingleChildCategoryForm;
        var isCustomPage = this.isPortfolio && this.categoryId && this.rootCategoryId === this.categoryId && this.router.url.indexOf('/custom/') !== -1;
        // build breadcrumb
        if (isRootCategoryPortfolio) {
            var breadcrumbItems = [];
            breadcrumbItems.push(new HeaderBreadcrumbItem(HeaderBreadcrumbComponent_1.NAV_TYPE_NONE, "nav.bar.workspace.base." + this.rootCategoryId, true));
            return Observable_1.Observable.of(breadcrumbItems);
        }
        else if (isOverviewPage || isRootCategoryForm || isSingleChildCategoryForm) {
            var breadcrumbItems = [];
            breadcrumbItems.push(new HeaderBreadcrumbItem(HeaderBreadcrumbComponent_1.NAV_TYPE_BASE, "nav.bar.workspace.base." + this.rootCategoryId, true));
            breadcrumbItems.push(new HeaderBreadcrumbItem(isOverviewPage
                ? HeaderBreadcrumbComponent_1.NAV_TYPE_NONE : HeaderBreadcrumbComponent_1.NAV_TYPE_OVERVIEW, 'ejustice_overview', true));
            return Observable_1.Observable.of(breadcrumbItems);
        }
        else if (isChildCategoryPortfolio || isChildCategoryForm) {
            return this.rootCategorySummaryPageConfigService.getCardConfigByCategory(this.categoryId, this.rootCategoryId).pipe(operators_1.map(function (childCategoryConfig) {
                var breadcrumbItems = [];
                breadcrumbItems.push(new HeaderBreadcrumbItem(HeaderBreadcrumbComponent_1.NAV_TYPE_BASE, "nav.bar.workspace.base." + _this.rootCategoryId, true));
                breadcrumbItems.push(new HeaderBreadcrumbItem(HeaderBreadcrumbComponent_1.NAV_TYPE_OVERVIEW, 'ejustice_overview', true));
                if (childCategoryConfig) {
                    breadcrumbItems.push(new HeaderBreadcrumbItem(isChildCategoryPortfolio
                        ? HeaderBreadcrumbComponent_1.NAV_TYPE_NONE : HeaderBreadcrumbComponent_1.NAV_TYPE_PORTFOLIO, childCategoryConfig.title));
                }
                return breadcrumbItems;
            }));
        }
        else if (isCustomPage) {
            var customPageUrl = this.router.url.split('/custom/')[1].split('?')[0];
            return this.rootCategorySummaryPageConfigService.getCardConfigByCustomUrl(customPageUrl, this.rootCategoryId).pipe(operators_1.map(function (customCardConfig) {
                var breadcrumbItems = [];
                breadcrumbItems.push(new HeaderBreadcrumbItem(HeaderBreadcrumbComponent_1.NAV_TYPE_BASE, "nav.bar.workspace.base." + _this.rootCategoryId, true));
                breadcrumbItems.push(new HeaderBreadcrumbItem(HeaderBreadcrumbComponent_1.NAV_TYPE_OVERVIEW, 'ejustice_overview', true));
                if (customCardConfig) {
                    breadcrumbItems.push(new HeaderBreadcrumbItem(HeaderBreadcrumbComponent_1.NAV_TYPE_NONE, customCardConfig.title));
                }
                return breadcrumbItems;
            }));
        }
        return Observable_1.Observable.of([]);
    };
    var HeaderBreadcrumbComponent_1;
    HeaderBreadcrumbComponent.NAV_TYPE_BASE = 1;
    HeaderBreadcrumbComponent.NAV_TYPE_OVERVIEW = 2;
    HeaderBreadcrumbComponent.NAV_TYPE_PORTFOLIO = 3;
    HeaderBreadcrumbComponent.NAV_TYPE_NONE = 4;
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderBreadcrumbComponent.prototype, "isPortfolio", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderBreadcrumbComponent.prototype, "categoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderBreadcrumbComponent.prototype, "rootCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HeaderBreadcrumbComponent.prototype, "rootEntityId", void 0);
    HeaderBreadcrumbComponent = HeaderBreadcrumbComponent_1 = __decorate([
        core_1.Component({
            selector: 'ejustice-header-breadcrumb',
            template: require('./header-breadcrumb.component.html'),
            styles: [require('./header-breadcrumb.component.css')]
        }),
        __param(4, core_1.Optional()), __param(4, core_1.Inject(summary_pages_navigation_prefix_1.SUMMARY_PAGES_NAVIGATION_PREFIX)),
        __metadata("design:paramtypes", [root_category_summary_page_config_service_1.RootCategorySummaryPageConfigService,
            entity_name_provider_service_1.EntityNameProviderService,
            router_1.Router,
            router_1.ActivatedRoute, String])
    ], HeaderBreadcrumbComponent);
    return HeaderBreadcrumbComponent;
}());
exports.HeaderBreadcrumbComponent = HeaderBreadcrumbComponent;
var HeaderBreadcrumbItem = /** @class */ (function () {
    function HeaderBreadcrumbItem(navigationType, name, isMessageKey) {
        if (isMessageKey === void 0) { isMessageKey = false; }
        this.isCurrent = navigationType === HeaderBreadcrumbComponent.NAV_TYPE_NONE;
        this.navigationType = navigationType;
        this.name = name;
        this.isMessageKey = isMessageKey;
    }
    return HeaderBreadcrumbItem;
}());
exports.HeaderBreadcrumbItem = HeaderBreadcrumbItem;
//# sourceMappingURL=header-breadcrumb.component.js.map